import logo from '../assets/Logo.png';

function LoadingScreen() {
    return (
        <div className="flex min-h-screen items-center justify-center bg-slate-950 px-6 text-white">
            <div className="flex flex-col items-center gap-6 text-center">
                <img src={logo} alt="CET & RC" className="logo-pulse h-28 aspect-square lg:h-32 object-contain" />
                <div>
                    <p className="text-2xl font-extrabold uppercase tracking-widest text-white/55">CET & RC</p>
                    <h2 className="mt-3 text-lg font-semibold">Please Hold On!</h2>
                    <p className="mt-2 text-sm text-white/65">We are preparing your page...</p>
                </div>
            </div>
        </div>
    );
}

export default LoadingScreen;